import React, { createContext, useContext, useState } from 'react';

export type TChatWidgetContext = {
  reloadPos: boolean;
  setReloadPos: (arg: boolean) => void;
  jsLoaded: boolean;
  setJsLoaded: (arg: boolean) => void;
  handleWidgetIndex: (isOpenDrawer: boolean, zIndex?: number) => void;
};

export const ChatWidgetContext = createContext<TChatWidgetContext>({
  reloadPos: false,
  setReloadPos: () => {},
  jsLoaded: false,
  setJsLoaded: () => {},
  handleWidgetIndex: () => {},
});

export const useChatWidget = (): TChatWidgetContext =>
  useContext(ChatWidgetContext);

export const DEFAULT_INDEX = 1000;

export const ChatWidgetContainer = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [reloadPos, setReloadPos] = useState(false);
  const [jsLoaded, setJsLoaded] = useState(false);

  const handleWidgetIndex = (isOpenDrawer: boolean, zIndex = DEFAULT_INDEX) => {
    const widgetWrapper = document.getElementById('widget-wrapper');

    if (!widgetWrapper) return;
    if (widgetWrapper instanceof HTMLElement && isOpenDrawer) {
      widgetWrapper.style.zIndex = `${zIndex}`;
    } else {
      widgetWrapper.style.removeProperty('z-index');
    }
  };

  return (
    <ChatWidgetContext.Provider
      value={{
        reloadPos,
        setReloadPos,
        jsLoaded,
        setJsLoaded,
        handleWidgetIndex
      }}
    >
      {children}
    </ChatWidgetContext.Provider>
  );
};
